<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">{{ this.device.name }}</h4>
              <p class="card-category"></p>
            </template>
            <div class="row">
              <!--              <div class="col-md-5">-->
              <!--                <base-input :disabled="true"-->
              <!--                            label="Name"-->
              <!--                            type="text"-->
              <!--                            v-model="device.name">-->
              <!--                </base-input>-->
              <!--              </div>-->
              <div class="col-md-5">
                <base-input :disabled="true"
                            label="Serial"
                            type="text"
                            v-model="device.serial">
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5">
                <base-input :disabled="true"
                            label="Latitude"
                            type="text"
                            v-model="device.latitude">
                </base-input>
              </div>
              <div class="col-md-5">
                <base-input :disabled="true"
                            label="Longitude"
                            type="text"
                            v-model="device.longitude">
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5">
                <base-input :disabled="true"
                            label="Last data date"
                            type="text"
                            v-model="device.lastDataDate">
                </base-input>
              </div>
              <div class="col-md-5">
                <base-input :disabled="true"
                            label="Last data timestamp"
                            type="text"
                            v-model="timestampStr">
                </base-input>
              </div>
            </div>
            <div class="text-center">
              <button style="margin-left: 20px" type="submit" class="btn btn-info btn-fill float-right"
                      v-on:click="openEditDevice()">
                Edit device
              </button>
              <button style="margin-left: 20px" type="submit" class="btn btn-info btn-fill float-right"
                      v-on:click="openAlerts()">
                Alerts
              </button>
              <button style="margin-left: 20px" type="submit" class="btn btn-info btn-fill float-right"
                      v-on:click="openDataChart()">
                Show data charts
              </button>
              <button style="margin-left: 20px" type="submit" class="btn btn-info btn-fill float-right"
                      v-on:click="openDataPowerList()"
                      v-if="this.isAdmin===true">
                Show data power list
              </button>
              <button type="submit" class="btn btn-info btn-fill float-right" v-on:click="openDataList()">
                Show data list
              </button>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">History Localizations</h4>
              <p class="card-category"></p>
              <l-table-params :actions="tableLocalizations.actions"
                              :columns="tableLocalizations.columns"
                              :data="tableLocalizations.data"
                              :map-name="tableLocalizations.mapName"
                              :map-value="tableLocalizations.mapValue"
                              class="table-hover table-striped">
              </l-table-params>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">History Localizations Map</h4>
            </template>
            <div id="map" class="map" style="height: 400px"></div>
          </card>
        </div>
      </div>
    </div>

    <l-modal-device-edit ref="modalEditDevice" :is-admin="this.isAdmin"/>
  </div>
</template>

<script>

  import Card from 'src/components/Cards/Card.vue'
  import LTableParams from 'src/components/TableParams.vue'
  import {millisecondsToStr} from "../../tools/DateTimeUtils";
  import {centerOfPoints} from "../../tools/MapTools";
  import LModalDeviceEdit from 'src/components/Modal/ModalDeviceEdit'
  import EventBus from "../../event-bus";

  const Vue = window.Vue;

  const tableColumnsLocalizations = ['Id', 'From', 'To', 'Name', 'City', 'Latitude', 'Longitude'];
  const tableDataLocalizations = [{}];
  const tableMapName = {};
  const tableMapValue = {};

  export default {
    name: "DeviceDetailsPage",
    components: {
      LTableParams,
      Card,
      LModalDeviceEdit
    },
    data() {
      return {
        isAdmin: false,
        map: null,
        device: null,
        timestampStr: null,
        tableLocalizations: {
          columns: [...tableColumnsLocalizations],
          data: [...tableDataLocalizations],
          mapName: {...tableMapName},
          mapValue: {...tableMapValue},
          actions: [
            {
              icon: 'database',
              handler: this.openDataLocalization
            },
            {
              icon: 'chart-bar',
              handler: this.openChartsLocalization
            },
          ]
        },
      }
    },
    mounted() {
      this.isAdmin = localStorage.getItem('isAdmin') === 'true';

      this.loadDevice();

      EventBus.$on('EVENT_RELOAD', data => {

        this.loadDevice();
      });
    },

    methods: {
      loadDevice() {
        this.$http.get('device/' + this.$route.params.deviceId)
          .then(result => {
            this.device = result.data;

            EventBus.$emit('EVENT_PATHS', [["/#/devices/list", 'Devices'], ['/#/devices/details/' + this.$route.params.deviceId, this.device.name]]);

            if (this.device.lastDataTimestamp !== null && this.device.lastDataTimestamp > 0) {
              this.timestampStr = millisecondsToStr(this.device.lastDataTimestamp);
            }
            this.loadLocalizationsHistory();

          }, error => {
            console.error(error);
          });
      },
      loadLocalizationsHistory() {
        this.$http.get('localization/history/list/' + this.$route.params.deviceId)
          .then(result => {
            this.tableLocalizations.data = result.data;
            this.initMap();
          }, error => {
            console.error(error);
          });
      },
      openDataList() {
        this.$router.push('/devices/data/' + this.device.id);
      },
      openDataPowerList() {
        this.$router.push('/devices/data/power/' + this.device.id);
      },
      openDataChart() {
        this.$router.push('/devices/charts/' + this.device.id);
      },
      openAlerts() {
        this.$router.push('/devices/alerts/' + this.device.id);
      },
      openDataLocalization(item) {
        this.$router.push('/devices/data/' + this.device.id + '/' + item.id);
      },
      openChartsLocalization(item) {
        this.$router.push('/devices/charts/' + this.device.id + '/' + item.id);
      },
      openEditDevice() {
        this.$refs.modalEditDevice.editDevice(this.device);
      },
      initMap() {
        let center = centerOfPoints(this.tableLocalizations.data);

        this.map = L.map('map').setView([center.latitude, center.longitude], center.zoom);
        this.tileLayer = L.tileLayer(
          'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          {
            maxZoom: 18,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
          }
        );
        this.tileLayer.addTo(this.map);

        for (let i = 0; i < this.tableLocalizations.data.length; i++) {
          let data = this.tableLocalizations.data[i];
          console.log(data);
          if (data.latitude !== null && data.latitude > 0 &&
            data.longitude !== null && data.longitude > 0) {
            let market = L.marker([data.latitude, data.longitude]).addTo(this.map);
            market.bindPopup(data.name);
          }
        }
      },
    }
  }
</script>
<style>
  .content {
    width: 100%;
    background: #f8f9fa;
  }

  .card-plain {
    margin-bottom: inherit;
  }

  .table-responsive {
    background: whitesmoke;
    border-color: #0e0e0e;
  }

  .card-body {
    background: #f8f9fa;
  }

  .cardPlain {
    margin: 10px;
    margin-top: 20px;
    background-color: #e5e5e5;
  }

  h5 {
    background: #E3E3E3;
  }

  .headStyle {
    background: cadetblue;
  }
</style>
